import React from "react";
import Input from "./Input";

export default class InputNumber extends React.Component<any, any> {
  handleBlur = (event: any) => {
    const { parser = parseFloat } = this.props;
    event.target.value = parser(event.target.value);

    if (isNaN(event.target.value)) {
      event.target.value = "";
    }

    const { field, onBlur } = this.props;
    field.onChange(event);
    field.onBlur(event);

    if (onBlur) onBlur(event);
  };

  handleChange = (event: any) => {
    const { field, onChange } = this.props;
    event.target.value = event.target.value.trim();

    field.onChange(event);
    if (onChange) onChange(event);
  };

  handleKeyPress = (event: any) => {
    if (!/\d|\./.test(event.key)) event.preventDefault();
    /* if (!/^[-]{0,1}[\d]*[,]?[\d]*[.]{0,1}[\d]+$/g.test(event.target.value)) */
  };

  render() {
    const { style, ...props } = this.props;
    return (
      <Input
        {...props}
        style={{ ...style, textAlign: "right" }}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        onKeyPress={this.handleKeyPress}
      />
    );
  }
}
